export default {
    title: 'Nutzer',
    email: 'E-Mail',
    phone: 'Telefon',
    customName: 'Anzeigename',
    last_login_at: 'Letzter Login',
    firstname: 'Vorname',
    organisationName: 'Organisationsname',
    organisation: 'Organisation',
    role_name: 'Rolle',
    created_at: 'Erstellt am',
    id: 'ID',
    impersonate: 'Support geben',
    emailNotVerified: 'E-Mailadresse wurde noch nicht verifiziert',
    resendEmailVerificationMail: 'E-Mail zur Verifizierung erneut senden',

    qf_onlyEmployees: 'Nur Mitarbeiter'
}